import {Injectable} from '@angular/core';

// models
import {CatalogObject, LineItem, ShopLineItemMap} from '../models/payment-item.model';
// stores
import {MenuItemForPayment} from '../models/cart-item.model';
import {Discount, Price} from '../models/restaurant.model';
// constants

@Injectable()
export class ConvertItemsService {

  public static fromCartItemsToShopLineItems(cartItems: MenuItemForPayment[]): ShopLineItemMap {
    const shopLineItems: ShopLineItemMap = {};

    cartItems.forEach((cartItem) => {
      let amount = 0;
      if (!shopLineItems || !shopLineItems[cartItem.locationId]) {
        shopLineItems[cartItem.locationId] = {amount: 0, line_items: [], discounts: []};
      }

      const variation = [new CatalogObject(cartItem.item.variation.id)];
      amount += cartItem.item.variation.price.amount;

      let modifiersCatalogObject;
      modifiersCatalogObject = cartItem.item.modifiers.map((modifier) => {
        amount += modifier.price.amount;
        if (modifier.name.includes('{Light}') || modifier.name.includes('{Regular}') || modifier.name.includes('{Extra}')) {
          const adHocName = modifier.name.replace('{Light}', '(Light)').replace('{Regular}', '(Regular)').replace('{Extra}', '(Extra)');
          return new CatalogObject(
            null,
            adHocName,
            new Price(modifier.price.amount, modifier.price.currency),
            modifier.onByDefault,
            modifier.hiddenFromCustomer,
            modifier.isSelected);
        }
        return new CatalogObject(modifier.id);
      });

      let lineItem: LineItem;
      lineItem = new LineItem(cartItem.item.quantity, cartItem.item.id, variation, modifiersCatalogObject, cartItem.item.specialInstructions);
      lineItem.metadata = cartItem?.metadata;

      shopLineItems[cartItem.locationId].amount += Math.ceil(amount);
      shopLineItems[cartItem.locationId].line_items.push(lineItem);
    });

    return shopLineItems;
  }
}
